/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description offsetReducer
 */

import { combineActions, handleActions } from 'redux-actions'

import {
  GET_LISTABLES_SUCCESS,
  HIDE,
  RESET_LISTABLES,
  RESET_SAVED_SEARCHES_VIEW,
  SET_LISTABLES_OFFSET,
} from '../constants/index'

const offsetReducer = handleActions(
  {
    [SET_LISTABLES_OFFSET]: (state, action) => {
      const offset = action.payload
      return offset > 0 ? offset : 0
    },
    [combineActions(HIDE, RESET_LISTABLES, RESET_SAVED_SEARCHES_VIEW)]: () => 0,
    [GET_LISTABLES_SUCCESS]: (state, action) => {
      const { payload } = action
      if (payload) {
        const { offset } = payload

        // capture the offset
        if (offset) {
          return offset
        }
        return 0
      }
      return state
    },
  },
  0
)

export default offsetReducer
